<div id="covHeader" class="bg-secondary-nvwa clearfix row mr-0">
  <div class="container pt-4 pl-5 pr-5">
    <div class="d-flex">
      <nav class="flex-bottom">
        <a
          id="engelsTab"
          [routerLink]="['/en']"
          [routerLinkActive]="language == 'EN' ? 'active' : ''"
          class="py-2 px-4 col-auto d-inline-block submenu"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="changeLanguage('EN')"
          data-shortcut="E"
          data-identifier="COV_CERTIFICAAT.ENGELS"
        >
          <h2 class="submenu">
            {{ "COV_CERTIFICAAT.ENGELS" | promptvalue | async }}
          </h2>
        </a>
        <a
          id="spaansTab"
          lang="es"
          [routerLink]="['/es']"
          [routerLinkActive]="language == 'ES' ? 'active' : ''"
          class="py-2 px-4 col-auto d-inline-block submenu"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="changeLanguage('ES')"
          data-shortcut="S"
          data-identifier="COV_CERTIFICAAT.SPAANS"
        >
          <h2 class="submenu">
            {{ "COV_CERTIFICAAT.SPAANS" | promptvalue | async }}
          </h2>
        </a>
      </nav>
    </div>
  </div>
</div>
